import { useCallback, useEffect, useState } from 'react'

import { F0ButtonToggle } from '@factorialco/f0-react'
import { VideoRecorder, VideoRecorderNegative } from '@factorialco/f0-react/icons/app'
import { useLocalParticipant, usePersistentUserChoices } from '@livekit/components-react'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

export const CameraButton = () => {
  const { userChoices, saveVideoInputEnabled } = usePersistentUserChoices()
  const { localParticipant } = useLocalParticipant()
  const [videoEnabled, setVideoEnabled] = useState(userChoices.videoEnabled)

  // Save settings when they change
  useEffect(() => {
    saveVideoInputEnabled(videoEnabled)
  }, [videoEnabled, saveVideoInputEnabled])

  const handleCameraToggle = useCallback(async () => {
    try {
      const newState = !videoEnabled
      await localParticipant.setCameraEnabled(newState)
      setVideoEnabled(newState)
    } catch (error) {}
  }, [videoEnabled, localParticipant])

  return (
    <F0ButtonToggle
      icon={videoEnabled ? VideoRecorder : VideoRecorderNegative}
      label={i18n.t('meetings.room.control_bar.camera.label')}
      onSelectedChange={() => {
        track(trackingEvents.meetings.ControlBarVideoButton, {
          isVideoEnabled: !videoEnabled,
        })
        handleCameraToggle()
      }}
      size="lg"
      selected={videoEnabled}
    />
  )
}
